import { track } from "../facade";

const dispatch = (action, label = null, value = null) =>
  track(action, {
    category: `Cart`,
    label,
    value,
  });

export const trackInBasket = (sku) => dispatch("In Basket", sku);
export const trackRemoved = (sku) => dispatch("Remove Item", sku);
export const trackProductChildName = (name) =>
  dispatch("Product Child Name", name);
export const trackEditItem = (sku) => dispatch("Edit item", sku);
export const trackEditAddons = (sku) => dispatch("Edit addons", sku);
export const trackAddAddons = (sku) => dispatch("Add addons", sku);
export const trackSaveCanvasChanges = (sku) =>
  dispatch("Save canvas changes", sku);
export const trackSaveAddonChanges = (sku) =>
  dispatch("Save addon changes", sku);
